import styled, { css } from 'styled-components'
import {
	WrapperColor as oldWrapperColor,
	Block,
	themeObject,
	textModels,
	media,
	Breakpoints,
	mediaOnly,
} from 'Pages/landings/newLandings/common/style'

export const WrapperColor = styled(oldWrapperColor)`
	padding-top: 80px;
	padding-bottom: 80px;
	${mediaOnly('padding-left: 24px; padding-right: 24px;', '0px', Breakpoints.sm)}
`
export const Wrapper = styled(Block)`
	${media('flex-direction: column;', Breakpoints.xl)}
`

export const Title = styled.p`
	color: ${themeObject.colors.grey[800]};
	text-align: center;
	${textModels('heading', 'h2')};
	margin-bottom: 48px;
`

export const ElementsWrapper = styled.div`
	display: grid;
	grid-template-columns: 1fr;
	row-gap: 16px;
	justify-content: space-between;
	${media('row-gap: 32px;', Breakpoints.ms)};
	${media(
		'grid-template-columns: 1fr 1fr; grid-template-rows: auto auto; gap: 32px;',
		Breakpoints.lx
	)};
	${mediaOnly('grid-template-columns: 1fr; grid-template-rows: initial;', '0px', Breakpoints.lx)}
`

const titlesStyle = css`
	padding: 8px 16px;
	border-radius: 8px;
	color: ${themeObject.colors.base.white};
	margin-bottom: 24px;
	${textModels('notAdaptive', 'xl', '600')};
	${media('margin: 0px 24px 0px 0px;', Breakpoints.xl)};
`

export const FirstTitle = styled.p`
	${titlesStyle};
	background-color: ${themeObject.colors.malachite[800]};
`

export const SecondTitle = styled.p`
	${titlesStyle};
	background-color: ${themeObject.colors.violet[500]};
`

export const ThirdTitle = styled.p`
	${titlesStyle};
	background-color: ${themeObject.colors.orange[500]};
`
